import React from 'react';
import {Box} from '@mui/material';
import {Icon, designSystemToken} from '@lightricks/react-design-system';
import styles from '../ContentSubmissionAnalysisModal.module.scss';

const DEFAULT_STAR_COUNT = 5;

export interface StarRatingProps {
  value: number | null;
  onChange: (value: number) => void;
  starCount?: number;
}

function StarRating({
  value,
  onChange,
  starCount = DEFAULT_STAR_COUNT,
}: StarRatingProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
      }}
      role="group"
      aria-label="Rate 1 to 5 stars"
    >
      {Array.from({length: starCount}, (_, i) => {
        const starValue = i + 1;
        const filled = value !== null && starValue <= value;
        return (
          <button
            key={starValue}
            type="button"
            onClick={() => onChange(starValue)}
            className={styles.starButton}
            aria-label={`${starValue} star${starValue === 1 ? '' : 's'}`}
            aria-pressed={filled}
          >
            <Icon
              name={filled ? 'Navigation-Star-Fill' : 'Navigation-Star-Line'}
              size="medium"
              appearance={filled ? 'primary' : 'neutral'}
              color={designSystemToken('semantic.bg.warning')}
            />
          </button>
        );
      })}
    </Box>
  );
}

export default StarRating;
